import { createSelector } from 'reselect';

const selectDomain = (state) => state.hand;

export const selectHandPosition = createSelector(
  [selectDomain], (state) => state.get('handPosition'),
);
